import { render, staticRenderFns } from "./InDevelopment.vue?vue&type=template&id=064ca84f&scoped=true&"
var script = {}
import style0 from "./InDevelopment.vue?vue&type=style&index=0&id=064ca84f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064ca84f",
  null
  
)

export default component.exports